<template>
  <v-container
    fluid
    class="my-md-12 px-md-6 mx-xl-auto"
    style="max-width: 1600px"
  >
    <v-row>
      <v-col>
        <h2
          v-text="$t('title.platforms')"
          class="text-md-h4 text--secondary"
        ></h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <PlatformList :platforms="filteredPlatforms" :loading="loading">
          <template #append>
            <FiltersButton
              :count="filterBadgeCount"
              @click="areFiltersVisible = true"
            />
          </template>
        </PlatformList>
      </v-col>
    </v-row>
    <FilterDrawer v-model="areFiltersVisible" @reset="resetFilters">
      <PlatformFilters v-model="filters" :platforms="platforms" />
    </FilterDrawer>
  </v-container>
</template>

<script>
import PlatformList from "../components/PlatformList";
import PlatformFilters from "../components/PlatformFilters";
import FilterDrawer from "../components/FilterDrawer";
import FiltersButton from "../components/FiltersButton";
import CounterAPI from "../lib/api";
import {
  activeFilterCount,
  emptyPlatformFilters,
  filterPlatforms,
} from "../lib/listFilters";

export default {
  name: "Home",

  components: {
    PlatformList,
    PlatformFilters,
    FilterDrawer,
    FiltersButton,
  },

  data() {
    return {
      api: new CounterAPI(process.env.COUNTER_API_ROOT),
      areFiltersVisible: false,
      filters: emptyPlatformFilters(),
      platforms: [],
      loading: false,
    };
  },

  computed: {
    filteredPlatforms() {
      return filterPlatforms(this.platforms, this.filters);
    },
    filterBadgeCount() {
      return activeFilterCount(this.filters);
    },
  },

  methods: {
    async getPlatforms() {
      this.loading = true;
      try {
        this.platforms = await this.api.getPlatforms();
      } finally {
        this.loading = false;
      }
    },
    resetFilters() {
      this.filters = emptyPlatformFilters();
    },
  },

  mounted() {
    this.getPlatforms();
  },
};
</script>
